const initialValuesRemocaoEleicaoModal = { titulo_eleicao: '' };

export default initialValuesRemocaoEleicaoModal;
